module.exports = __webpack_public_path__ + "static/wraith-4707675a5ec5ca1e9f613a04983f7de2.jpeg";